import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import StrongForceDaily from "@/pages/StrongForceDaily";
import Resources from "@/pages/Resources";
import ResourceCategory from "@/pages/ResourceCategory";
import Shop from "@/pages/Shop";
import InnerCircle from "@/pages/InnerCircle";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import ScrollToTop from "@/components/ScrollToTop";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/the-strong-force-daily" element={<StrongForceDaily />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/resources/:slug" element={<ResourceCategory />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/inner-circle" element={<InnerCircle />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/checkout/success" element={<CheckoutSuccess />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default App;
